<template>
  <div class="setting">
    <!-- 左侧菜单 -->
    <div class="setting-l">
      <div class="setting-l-tl">设置</div>
      <el-menu
        :router="true"
        :default-active="activeMenu"
        :unique-opened="true"
        @select="handleOpen"
        class="el-menu-vertical"
      >
        <el-submenu
          v-for="(submenu, index) in menuList"
          :key="index"
          :index="submenu.path"
        >
          <template slot="title">{{ submenu.meta.title }}</template>
          <el-menu-item
            v-for="(item, idx) in submenu.children"
            :key="idx"
            :index="item.path"
            :route="item.path"
          >
            {{ item.meta.title }}
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

    <!-- 右侧显示内容 -->
    <div class="setting-r">
      <div class="setting-r-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeMenu: "",
    };
  },
  mounted() {
    this.activeMenu = this.$route.path;
  },
  computed: {
    menuList() {
      return this.$store.state.userStore.menu || [];
    },
  },
  watch: {
    $route(to, from) {
      this.activeMenu = to.path;
    },
  },
  methods: {
    handleOpen(index, indexPath) {
      // console.log("打开菜单:", index, indexPath[0]);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 左侧菜单的样式 */
.el-menu-vertical:not(.el-menu--collapse) {
  width: 100%;
  height: 100%;
}

::v-deep .el-menu {
  border-right: none;
}

::v-deep .el-submenu__title {
  font-size: 15px;
  font-weight: 500;
  text-align: left;
  height: 50px;
  line-height: 50px;
  padding-left: 40px !important;
}

::v-deep .el-submenu__title:hover {
  background-color: #f5f5f5;
}

::v-deep .el-submenu.is-active .el-submenu__title {
  color: #1677ff;
}

::v-deep .el-submenu .el-menu-item {
  font-size: 15px;
  text-align: left;
  height: 40px;
  line-height: 40px;
  padding: 0 60px !important;
}

::v-deep .el-menu-item.is-active {
  font-weight: 500;
  background-color: #e6f4ff !important;
}

::v-deep .el-menu-item:hover {
  background-color: #f5f5f5;
}

::v-deep .el-menu-item.is-active::after {
  content: "";
  position: absolute;
  right: 0;
  width: 2px;
  height: 100%;
  background-color: #1677ff;
}

/* 整体布局 */
.setting {
  display: flex;
}

.setting-l {
  width: 254px;
  height: 100vh;
  // border-right: 1px solid #e6e6e6;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  .setting-l-tl {
    text-align: left;
    padding: 20px 0px 10px 40px;
    font-weight: bold;
    font-size: 19px;
  }
}

.setting-r {
  flex: 1;
  height: calc(100vh - 40px);
  background: #f5f5f5;
  padding: 20px;

  .setting-r-content {
    background: #fff;
    height: 100%;
    border-radius: 5px;
    position: relative;
    overflow: auto;
  }
}
</style>
